import packagingMaterialSelectStories from "./PackagingMaterialSelect.stories";

const stories = {
  name: "packaging-materials",
  children: [packagingMaterialSelectStories],
};

export default stories;
